import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme(() => ({
  width: '100%',
  background: material3.color.surfaceContainerLow,
  border: `1px solid ${material3.color.outlineVariant}`,
  borderRadius: material3.shape.large,
  boxShadow: material3.elevation.level1,
  overflow: 'hidden',
  transition: 'border-color .18s ease, box-shadow .18s ease, transform .18s ease',
  '&:hover': {
    borderColor: material3.color.primaryLight,
    boxShadow: material3.elevation.level2,
    transform: 'translateY(-1px)'
  }
}));

const link = withTheme(() => ({
  width: '100%',
  color: material3.color.textPrimary,
  textDecoration: 'none',
  display: 'flex',
  ':hover': {
    cursor: 'pointer',
  }
}));

const btnWrapper = withTheme((theme) => ({
  width: '22%',
  minWidth: '160px',
  paddingY: theme.spacing(2),
  paddingX: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    paddingRight: theme.spacing(3)
  }
}));

const pictureWrapper = withTheme((theme) => ({
  width: '33%',
  minWidth: '120px',
  maxWidth: '160px',
  cursor: 'pointer',
  background: material3.color.surfaceContainer,
  [theme.breakpoints.up('sm')]: {
    minWidth: '170px',
    maxWidth: '260px',
  }
}));

const RGDWrapper = withTheme(() => ({
  width: '100%',
  background: material3.color.primaryLight,
  color: material3.color.primaryDark,
  paddingY: '2px',
  '& .MuiTypography-root': {
    fontWeight: material3.typography.labelWeight,
    color: material3.color.primaryDark
  }
}));

const imageCrop = withTheme(() => ({
  width: '100%',
  overflow: 'hidden',
  background: material3.color.surfaceContainer,
  '& img': {
    display: 'block'
  }
}));

const infoWrapper = withTheme((theme) => ({
  width: '100%',
  padding: theme.spacing(2),
  gap: theme.spacing(0.5),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(4)
  }
}));

const styles = {
  container,
  link,
  btnWrapper,
  pictureWrapper,
  RGDWrapper,
  imageCrop,
  infoWrapper
};

export default styles;
